<template>
  <div>
    <indexHome msg="Welcome to Your Vue.js App" />
  </div>
</template>

<script>
import indexHome from './components/index.vue';

export default {
  name: 'App',
  components: {
    indexHome,
  },
  created() {
  }
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
body {
  padding: 0;
  margin: 0;
}
</style>
